import * as React from 'react'
import {
  Bell as AlarmIcon,
  Blocks as FunctionBlockIcon,
  Box as ControlModuleIcon,
  Cable as IoModuleIcon,
  CircleDot as IoChannelIcon,
  Cpu as CeeIcon,
  Gauge as ControllerIcon,
  SlidersHorizontal as SetpointIcon,
  Tag as ControlTagIcon
} from 'lucide-react'
import type { PlantDcsNodeKind } from '@axilon-apps/domains-ontology-ui-state'

type IconComponent = React.ComponentType<{ size?: number | string; className?: string }>

/**
 * Lucide icon assignments per DCS node kind. Used by both the left-rail
 * tree and the right-pane detail header. Gauge (not CircuitBoard) keeps
 * the DCS tab visually distinct from PLC.
 */
const ICONS_BY_KIND: Record<PlantDcsNodeKind, IconComponent> = {
  DcsController: ControllerIcon,
  Cee: CeeIcon,
  ControlModule: ControlModuleIcon,
  FunctionBlock: FunctionBlockIcon,
  IoModule: IoModuleIcon,
  IoChannel: IoChannelIcon,
  ControlTag: ControlTagIcon,
  ControlAlarm: AlarmIcon,
  ControlSetpoint: SetpointIcon
}

export function dcsIconFor(kind: PlantDcsNodeKind): IconComponent {
  return ICONS_BY_KIND[kind]
}

const SINGULAR_LABELS: Record<PlantDcsNodeKind, string> = {
  DcsController: 'DCS controller',
  Cee: 'CEE',
  ControlModule: 'Control module',
  FunctionBlock: 'Function block',
  IoModule: 'I/O module',
  IoChannel: 'I/O channel',
  ControlTag: 'Control tag',
  ControlAlarm: 'Control alarm',
  ControlSetpoint: 'Control setpoint'
}

export function dcsLabelFor(kind: PlantDcsNodeKind): string {
  return SINGULAR_LABELS[kind]
}
